import { Action } from "@ngrx/store";
import { IUtilitReducer } from "./../models/utility-reducer.interface";

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

export const IS_DIAMOND_AIRLINE = "IS_DIAMOND_AIRLINE";
export const IS_BOOKING_HUBDROP_BOOKING = "IS_BOOKING_HUBDROP_BOOKING";
export const UPDATE_AMEND_ZONE_ID = "UPDATE_AMEND_ZONE_ID";
export const SET_SELECTED_POST_OFFICE = 'SET_SELECTED_POST_OFFICE';
export const REFRESH_UTILITY_REDUCER = "REFRESH_UTILITY_REDUCER";
export const RESET_UTILITY_REDUCER = "RESET_UTILITY_REDUCER";
export const SET_CURRENT_BAG_ITEMS = "SET_CURRENT_BAG_ITEMS";
export const UPDATE_OTP_VERIFIED = 'UPDATE_OTP_VERIFIED';
export const USER_ACCOUNT_UPDATE_STATUS = 'USER_ACCOUNT_UPDATE_STATUS';
export const HUBDROP_AVAILABILITY_STATUS = 'HUBDROP_AVAILABILITY_STATUS';
export const UPDATE_BOOKER_EMAIL = 'UPDATE_BOOKER_EMAIL';

const initState: IUtilitReducer = {
  isDiamondAirline: false,
  isHubdropAvailable: false,
  isHubdropBooking: false,
  selectPostOffice: null,
  bagItems: {
    bags: 1,
    childEquipment: 0,
    oversizeItem: 0
  },
  amendZoneId: '',
  userOTPVerified: false,
  userAccountDetailsUpdate: false,
  bookerEmail: '',
};

export function utilityReducer(
  state: IUtilitReducer = initState,
  action: ActionWithPayloadInterface
) {
  switch (action.type) {
    case UPDATE_OTP_VERIFIED:
      return Object.assign({}, state, { userOTPVerified: action.payload });
    case USER_ACCOUNT_UPDATE_STATUS:
        return Object.assign({}, state, { userAccountDetailsUpdate: action.payload });
    case IS_DIAMOND_AIRLINE:
      return Object.assign({}, state, { isDiamondAirline: action.payload });
    case UPDATE_AMEND_ZONE_ID:
      return Object.assign({}, state, { amendZoneId: action.payload });
    case HUBDROP_AVAILABILITY_STATUS:
           return Object.assign({}, state, { isHubdropAvailable: action.payload });
    case IS_BOOKING_HUBDROP_BOOKING:
      return Object.assign({}, state, { isHubdropBooking: action.payload });
    case SET_SELECTED_POST_OFFICE:
      return Object.assign({}, state, { selectPostOffice: action.payload });
    case SET_CURRENT_BAG_ITEMS:
      return Object.assign({}, state, { bagItems: action.payload });
    case UPDATE_BOOKER_EMAIL:
      return Object.assign({}, state, { bookerEmail: action.payload });
    case REFRESH_UTILITY_REDUCER:
      return Object.assign({}, action.payload);
    case RESET_UTILITY_REDUCER:
      return Object.assign({}, initState);
    default:
      return state;
  }
}
